/* global TimelineMax */

// require('../vendor/pixi-extra-filters');// for the outline filter

var _ = require('lodash');
var PIXI = require('pixi.js');
var OutlineFilter = require('./OutlineFilter');

var Flux = require('./flux');

var PixiFlux = function(opts)
{
    this.options = _.extend({
        antialias: true,
        width: window.innerWidth,
        height: window.innerHeight,
        showWalls: false,
        wallColor: 0xFF0000,
        baseWidth: window.innerWidth,
        baseHeight: window.innerHeight,
        maxGhostParticles: 0,
        particleScale: 1,
        outlineColor: 0xFFFFFF, // 0x20cf66 // 0x000000
        outlineSize: 1,
        initialTicks: 0,
        offsetY: 0,
        mouseOffset: 0,
        container: null,
        walls: [],
        blobs: [],
        blobTexture: [
            '/img/flux/circle-B-01.png',
            '/img/flux/circle-B-02.png',
            '/img/flux/circle-B-03.png',
        ],
    }, opts);
    this.flux = null;
    this.particles = null;
    this.ghostPositions = null;
    this.mouseOffset = this.options.mouseOffset;
    this.mainContainer = this.options.container;
    this.spritesContainer = new PIXI.Sprite();
    this.wallsContainer = new PIXI.Sprite();
    this.wallsContainer.interactiveChildren = false;

    // console.log(this.options.width, this.options.height, this.options.baseWidth, this.options.baseHeight);

    this.setContainer(this.mainContainer);
    this.init();
};

PixiFlux.prototype.setContainer = function(container, parentWidth)
{
    if (container === null || typeof container === 'undefined') {
        return;
    }
    this.mainContainer = container;

    container.addChild(this.spritesContainer);
    container.addChild(this.wallsContainer);

    if (parentWidth > 0) {
        container.scale.x = parentWidth / this.options.width;
        container.scale.y = parentWidth / this.options.width;
    }
};

PixiFlux.prototype.init = function()
{
    // remove useless options
    /* var fluxOpts = _.filter(this.options, function(opt){
        return opt !== 'container';
    }); */

    this.flux = new Flux(this.options);
    this.buildParticlesShapes();
    this.buildBodiesShapes();
    this.firstTick();

    for (var i = 0, il = this.options.initialTicks; i < il; i++)
    {
        this.flux.tick(true);
    }

    window.addEventListener('resize', _.bind(this.setOutlineSize, this));
};

PixiFlux.prototype.updateIntensity = function(intensity, opts)
{
    opts = _.extend({
        animate: true,
        cleanTint: 0xFFFFFF,
        dirtyTints: [0]
    }, opts);

    var color;
    var cleanTint = opts.cleanTint;
    var dirtyTint;
    var newTint;
    var animationDuration = opts.animate ? 0.3 : 0;
    var animationDelay = opts.animate ? 0.0003 : 0;
    var timeline = new TimelineMax({ paused: true });
    this.particles.map(function(particle, index){
        dirtyTint = opts.dirtyTints[_.random(0, opts.dirtyTints.length-1)];
        // dirtyTint = opts.dirtyTints[0];
        if (particle.rgbaColor[0] === 0 && particle.rgbaColor[1] === 0 && particle.rgbaColor[2] === 0)// clean
        {
            newTint = cleanTint;
            if (intensity === 2) {
                newTint = _.random(0, 10) === 0 ? cleanTint:opts.dirtyTints[1];
            } else if (intensity === 3) {
                newTint = _.random(0, 10) === 0 ? cleanTint:opts.dirtyTints[0];
            }
        } else if (particle.rgbaColor[0] === 255 && particle.rgbaColor[1] === 0 && particle.rgbaColor[2] === 0)// dirty intensity 1+
        {
            newTint = dirtyTint;
        } else if (particle.rgbaColor[0] === 0 && particle.rgbaColor[1] === 255 && particle.rgbaColor[2] === 0)// dirty intensity 2+
        {
            newTint = intensity < 2 ? cleanTint : dirtyTint;
        } else if (particle.rgbaColor[0] === 0 && particle.rgbaColor[1] === 0 && particle.rgbaColor[2] === 255)// dirty intensity 3
        {
            newTint = intensity < 3 ? cleanTint : dirtyTint;
        }
        timeline.to(particle, animationDuration, {
            colorProps: {
                tint: newTint,
                format: 'number',
            },
            delay: index * animationDelay,
        }, 0);
    });

    timeline.play();
};

PixiFlux.prototype.applyForce = function(x, y)
{
    this.flux.applyForce(x, y);
};

PixiFlux.prototype.getMovingWalls = function()
{
    return this.flux.getMovingWalls();
};

PixiFlux.prototype.updateMouseDownPosition = function(mouseDownPosition)
{
    this.flux.updateMouseDownPosition(mouseDownPosition, this.mouseOffset);
};

PixiFlux.prototype.setOutlineSize = function(width, height)
{
    if (this.options.outlineSize > 0) {
        this.outlineFilter.viewWidth = window.innerWidth;
        this.outlineFilter.viewHeight = window.innerHeight;
        // console.log('wh', this.options.width, this.options.height);
    }
};

PixiFlux.prototype.buildParticlesShapes = function()
{
    this.particles = [];
    var systems = this.flux.getParticleSystems();
    var maxGhostParticles = this.options.maxGhostParticles;

    var system, particles, color, particlesCount, blobName, tempBall, c, i, j, k, l;
    var allParticles = new PIXI.Sprite();

    this.spritesContainer.addChild(allParticles);

    var options = this.options;
    if (options.outlineSize > 0) {
        var outlineFilter = this.outlineFilter = new OutlineFilter(window.innerWidth, window.innerHeight, options.outlineSize, options.outlineColor);
        allParticles.filters = [outlineFilter];
        // console.log('outline');
    }

    var texture = this.options.blobTexture;

    for(i = 0, l = systems.length; i < l; i++)
    {
        system = systems[i];
        particles = system.GetPositionBuffer();
        color = system.GetColorBuffer();
        particlesCount = particles.length;

        for (j = 0, c = 0; i < particlesCount; i+=2,c+=4)
        {
            for (k = 0; k <= maxGhostParticles; k++)
            {
                tempBall = new PIXI.Sprite.fromImage(texture[_.random(0, texture.length-1)]);
                tempBall.rgbaColor = [color[c], color[c+1], color[c+2], color[c+3]];
                tempBall.anchor.x = 0.5;
                tempBall.anchor.y = 0.5;
                tempBall.scale.x = tempBall.scale.y = 1;
                tempBall.alpha = 1 - k / (maxGhostParticles || 1);
                this.particles.push(tempBall);
                allParticles.addChild(tempBall);// tmp
            }
        }
    }

    this.ghostPositions = [];
};

PixiFlux.prototype.buildBodiesShapes = function()
{
    var bodies = this.flux.getBodies();
    this.walls = [];
    for (var i = 0, max = bodies.length; i < max; i++)
    {
        var body = bodies[i];
        var maxFixtures = body.fixtures.length;
        var transform = body.GetTransform();
        var position = body.GetPosition();
        var wall = new PIXI.Container();
        for (var j = 0; j < maxFixtures; j++)
        {
            var fixture = body.fixtures[j];
            var obj = this.buildWallShape(fixture.shape);
            wall.addChild(obj);
        }
        var name = 'body_'+i;
        if(!this.options.showWalls)
        {
            wall.visible = false;
        }
        this.walls.push(wall);
        this.wallsContainer.addChild(wall);
    }
};

PixiFlux.prototype.buildWallShape = function(shape)
{
    var graphic = new PIXI.Graphics();
    var wallColor = this.options.wallColor;
    graphic.beginFill(wallColor);
    graphic.lineStyle(1, wallColor);
    var firstX = 0;
    var firstY = 0;
    for (var i = 0, vl = shape.vertices.length; i < vl; i++)
    {
        var vertice = shape.vertices[i];
        var x = vertice.x * this.flux.options.meter;
        var y = vertice.y * this.flux.options.meter;

        if(i === 0)
        {
            firstX = x;
            firstY = y;
            graphic.moveTo(x, y);
        }
        else
        {
            graphic.lineTo(x, y);
        }
    }
    graphic.lineTo(firstX, firstY);

    return graphic;
};

PixiFlux.prototype.destroy = function()
{
    if (this.flux)
    {
        this.flux.destroy();
    }
};

PixiFlux.prototype.resetShapes = function()
{
    if (this.mainContainer) {
        this.mainContainer.removeChildren();
    }
    window.removeEventListener('resize', _.bind(this.setOutlineSize, this));
};

PixiFlux.prototype.firstTick = function() {
    let index = 0;
    const particleScale = this.options.particleScale;
    const particleSystems = this.flux.getParticleSystems();
    const maxGhostParticles = this.options.maxGhostParticles;
    let system, particles, color, particlesCount,
        particleX, particleY, sprite,
        psi, psl, i, c, k;

    for (psi = 0, psl = particleSystems.length; psi < psl; psi += 1) {
        system = particleSystems[psi];
        particles = system.GetPositionBuffer();
        particlesCount = particles.length;

        for (i = 0, c = 0; i < particlesCount; i += 2, c += 4) {
            for (k = 0; k <= maxGhostParticles; k += 1) {
                sprite = this.particles[index];
                sprite.scale.x = particleScale;
                sprite.scale.y = particleScale;
                index++;
            }
        }
    }
};

PixiFlux.prototype.tick = function() {
    // console.log('tick', this.options);
    this.flux.tick();
    const scale = 1; // this.options.width / this.options.baseWidth;
    // const particleScale = this.options.particleScale;

    let index = 0;
    const meter = this.flux.options.meter;
    const particleSystems = this.flux.getParticleSystems();
    // const ghostPositions = this.ghostPositions;
    const maxGhostParticles = this.options.maxGhostParticles;
    let system, particles, color, particlesCount,
        particleX, particleY, sprite,
        psi, psl, i, c, k;

    // if (maxGhostParticles > 0) {
    //     ghostPositions.unshift([]);
    // }

    for (psi = 0, psl = particleSystems.length; psi < psl; psi += 1)
    {
        system = particleSystems[psi];
        particles = system.GetPositionBuffer();
        color = system.GetColorBuffer();
        particlesCount = particles.length;

        for (i = 0, c = 0; i < particlesCount; i += 2, c += 4) {
            particleX = particles[i]*meter;
            particleY = particles[i+1]*meter;

            for (k = 0; k <= maxGhostParticles; k += 1)
            {
                sprite = this.particles[index];
                sprite.x = particleX * scale;
                sprite.y = particleY * scale;

                // if (k > 0 && ghostPositions[k-1])
                // {
                //     sprite.x = ghostPositions[k-1][i] * scale;
                //     sprite.y = ghostPositions[k-1][i+1] * scale;
                // }

                // sprite.scale.x = particleScale;
                // sprite.scale.y = particleScale;
                index++;
            }

            // if (maxGhostParticles > 0)
            // {
            //     ghostPositions[0][i] = particleX;
            //     ghostPositions[0][i+1] = particleY;
            // }
        }
    }

    // console.log('index', index);

    // if (ghostPositions.length > this.options.maxGhostParticles)
    // {
    //     ghostPositions.pop();
    // }

    const bodies = this.flux.getBodies();
    let body, maxFixtures, transform, position, angle, wallX, wallY;

    const max = bodies.length;

    for (i = 0; i < max; i += 1) {
        body = bodies[i];
        // maxFixtures = body.fixtures.length;
        transform = body.GetTransform();
        position = body.GetPosition();
        angle = body.GetAngle();

        wallX = position.x * meter;
        wallY = position.y * meter;

        this.walls[i].position.x = wallX * scale;
        this.walls[i].position.y = wallY * scale;
        this.walls[i].rotation = angle;
        this.walls[i].scale.x = scale;
        this.walls[i].scale.y = scale;
    }
};

module.exports = PixiFlux;



// WEBPACK FOOTER //
// ./js/lib/pixi-flux.js